/** Marks a drawing's svg as an icon, so slots size it like a Lucide icon; a picture with its own size has none. */
export const ICON_ATTRIBUTE = 'data-icon';

export const ICON_MARKER = { [ICON_ATTRIBUTE]: true } as const;

// MUI's own Material icons aren't icons here: the theme draws Lucide icons in their place (themeIcons.test.tsx).
/** The `svg` stays outside `:where`, so the selector is as specific as an element (0,0,1), whatever the list. */
export const ICON_SVG = `svg:where(.lucide, [${ICON_ATTRIBUTE}])`;
